/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as contactActions from '../ContactInfo/actions';
import * as Constants from './Constants';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
import { setSession, getServiceUrlandE2eRequestId, checkErrorCode, isExpressCheckout } from '../../components/common/Helpers/index';
import { logError, getErrorLogObj } from '../../services/loggerService';
import { saveItemToStore } from '../../utils/sessionStorage';

import logger from '../../components/common/ErrorBoundary/logger_new';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';
import { checkInvalidCaseCartError } from '../../components/common/Helpers/commonLog';

function* getDataFromApi({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    const apiResponse = yield call(Actions.getData, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_DATA_SUCCESS, response: apiResponse.data });
    } else if (apiResponse?.data?.errors) {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getDataFromApi ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    if (error) {
      const errorLog = getErrorLogObj({
        eventType: 'CustomLog',
        message: 'GENERIC_PAGE',
        note: 'from appointmentschedule getDataFromApi sagas',
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().appointmenturl}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

// for App schedule
function* getDataForAppSchedule({ data }) {
  let errorAppointment = false;
  let appScheduleDetails = null;
  yield put({ type: Constants.ERR_OCCURED, errorAppointment });
  yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    const apiResponse = yield call(Actions.getSchedule, data);
    if (apiResponse && apiResponse.data && apiResponse.data.statusCode === '0' && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_DATA_FROM_APP_SCHEDULE_SUCCESS, response: apiResponse.data });
      // yield invokeTagging('cpc-selected_plan');
      // hideLoader();
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorAppointment = true;
        appScheduleDetails = getServiceUrlandE2eRequestId('getDataForAppSchedule', apiResponse);
        yield put({ type: Constants.GET_DATA_FROM_APP_SCHEDULE_FAIL, response: apiResponse.data });
      }
      yield put({ type: Constants.ERR_OCCURED, errorAppointment, serviceinfo: appScheduleDetails });
      yield put({ type: Constants.NO_SLOTS_AVAILABLE, response: apiResponse.data });
      yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });

      if (apiResponse?.data?.errors) {
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getDataForAppSchedule ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      // yield invokeTagging('cpc-selected_plan');
      // hideLoader();
    }
  } catch (error) {
    if (error) {
      const errorLog = getErrorLogObj({
        eventType: 'CustomLog',
        message: 'GENERIC_PAGE',
        note: 'from getDataForAppSchedule sagas catch',
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().get5GProAppointments}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
    yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // hideLoader();
  } finally {
    hideLoader();
  }
  // yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* submitOrder(data) {
  let errorAppointment = false;
  let orderWriteCaseError = false;
  let submitOrderDetails = null;
  let notSubmittedPayment = false;
  yield put({ type: 'NOT_SUBMITTED_PAYMENT', notSubmittedPayment });
  yield put({ type: Constants.ERR_OCCURED, errorAppointment });
  yield put({ type: 'ORDERWRITE_CASE_ERROR', response: orderWriteCaseError });
  yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: null });
  try {
    showLoader();
    const apiResponse = yield call(Actions.getSubmitOrder, data);
    if (apiResponse) {
      if (apiResponse.data.errors) {
        const checkErrorCodeFlag = checkErrorCode(apiResponse?.data?.errors && apiResponse?.data?.errors[0] && apiResponse?.data?.errors[0]?.id);
        if (checkErrorCodeFlag) {
          yield put({ type: Constants.BUTTON_DISABLE, response: true });
        }
        const isAuth = apiResponse.data.errors.some((o) => {
          if (o?.name && o.name.includes('FULL_AUTH_FAILED')) {
            return o;
          }
        });
        if (isAuth) {
          if (apiResponse.data.errors && apiResponse.data.errors[0] && apiResponse.data.errors[0].id && apiResponse.data.errors[0].id === '3403') {
            yield put({ type: Constants.SUBMIT_SUCCESS, response: true });
            // setSession('OrderSubmitted', 'Y'); // ACT145-123 OrderSubmitted added
            setSession('isSubmitted', 'Y');
            yield put({ type: 'CLEAR_COUPON_VALUE' });
            if (!(data === 'ReviewOrderPage')) {
              hideLoader();
            }
          } else {
            saveItemToStore('show', 'true');
            const errorDetails = true;
            // serviceDetails = getServiceUrlandE2eRequestId('from submitOrder sagas isAuth', apiResponse);

            yield put({ type: Constants.ERORR_SUBMIT, errorDetails });
            yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorDetails, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
            yield put({ type: 'CEF_REVIEW_ORDER_ERROR', response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
            // hideLoader();
            if (apiResponse?.data?.errors) {
              if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `submitOrder ${apiResponse?.data?.loggerData.note}`;
              logger(apiResponse?.data?.loggerData);
            }
          }
        } else if (
          apiResponse?.data?.errors &&
          apiResponse?.data?.errors[0] &&
          apiResponse?.data?.errors[0]?.id &&
          apiResponse?.data?.errors[0]?.id === '3002'
        ) {
          notSubmittedPayment = true;
          submitOrderDetails = getServiceUrlandE2eRequestId('submitOrder', apiResponse);
          yield put({ type: 'NOT_SUBMITTED_PAYMENT', notSubmittedPayment, serviceinfo: submitOrderDetails });
          yield put({ type: Constants.SUBMIT_SUCCESS, response: apiResponse.data, flagToggle: true });
          yield put({
            type: Constants.CEF_APPOINTMENT_ERROR,
            response: notSubmittedPayment,
            errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
          });
          yield put({ type: 'CEF_REVIEW_ORDER_ERROR', response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
          if (apiResponse?.data?.errors) {
            if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `submitOrder ${apiResponse?.data?.loggerData.note}`;
            logger(apiResponse?.data?.loggerData);
          }
        } else {
          if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
            if (apiResponse?.status === 400 && checkInvalidCaseCartError(apiResponse.data.errors)) {
              orderWriteCaseError = true;
              submitOrderDetails = getServiceUrlandE2eRequestId('submitOrder', apiResponse);
              yield put({
                type: Constants.CEF_APPOINTMENT_ERROR,
                response: orderWriteCaseError,
                errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
              });
            } else {
              errorAppointment = true;
              submitOrderDetails = getServiceUrlandE2eRequestId('submitOrder', apiResponse);
              yield put({
                type: Constants.CEF_APPOINTMENT_ERROR,
                response: errorAppointment,
                errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
              });
              yield put({ type: 'CEF_REVIEW_ORDER_ERROR', response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
            }
          }
          yield put({ type: Constants.ERR_OCCURED, errorAppointment, serviceinfo: submitOrderDetails });
          yield put({ type: 'ORDERWRITE_CASE_ERROR', response: orderWriteCaseError, serviceinfo: submitOrderDetails });
          // yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          yield put({ type: Constants.SUBMIT_SUCCESS, response: apiResponse.data, flagToggle: true });
          // setSession('isSubmitted', 'Y');
          // hideLoader();
          if (apiResponse?.data?.loggerData) apiResponse.data.loggerData.note = `submitOrder ${apiResponse?.data?.loggerData.note}`;
          logger(apiResponse?.data?.loggerData);
        }
      } else {
        yield put({ type: Constants.SUBMIT_SUCCESS, response: true });
        yield put({ type: Constants.SUBMIT_SUCCESS_ORDERWRITE, response: apiResponse?.data });

        setSession('isSubmitted', 'Y');

        yield put({ type: 'CLEAR_COUPON_VALUE' });
        if (!(data === 'ReviewOrderPage')) {
          hideLoader();
        }
      }
    } else {
      // hideLoader();
      errorAppointment = true;
      submitOrderDetails = getServiceUrlandE2eRequestId('submitOrder', apiResponse);

      yield put({ type: Constants.ERR_OCCURED, errorAppointment, serviceinfo: submitOrderDetails });
      yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
      yield put({ type: 'CEF_REVIEW_ORDER_ERROR', response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });

      if (apiResponse?.data?.loggerData) apiResponse.data.loggerData.note = `submitOrder ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    // hideLoader();
    errorAppointment = true;
    submitOrderDetails = {
      method: 'submitOrder',
    };
    yield put({ type: Constants.ERR_OCCURED, errorAppointment, serviceinfo: submitOrderDetails });
    yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    yield put({ type: 'CEF_REVIEW_ORDER_ERROR', response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // logError('submitOrder', error, FE_API_JS_ERROR);
    if (error) {
      const errorLog = getErrorLogObj({
        note: 'from submitOrder sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().submitOrder}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
  } finally {
    hideLoader();
  }
}
// self date Update
function* selfInstallDateUpdate({ data }) {
  try {
    yield put({ type: 'SAVE_SELF_INSTALL_DATE_SUCCES', response: data });
    // yield invokeTagging('cpc-selected_plan');
  } catch (error) {
    yield put({ type: Constants.ERR_OCCURED });
  }
}

function* updateSelfInstallation({ data }) {
  let errorAppointment = false;
  let updateSelfInstallationDetails = null;
  let notSubmittedPayment = false;
  yield put({ type: Constants.ERR_OCCURED, errorAppointment });
  yield put({ type: 'NOT_SUBMITTED_PAYMENT', notSubmittedPayment });
  yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: null });
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    const apiResponse = yield call(Actions.postSelf, data);
    if (apiResponse) {
      // redirectTo(this.props.history, 'confirmation')
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorAppointment = true;
        updateSelfInstallationDetails = getServiceUrlandE2eRequestId('updateSelfInstallation', apiResponse);

        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `updateSelfInstallation ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.ERR_OCCURED, errorAppointment, serviceinfo: updateSelfInstallationDetails });
      const submitOrderRes = yield call(Actions.getSubmitOrder, data);
      if (submitOrderRes) {
        // yield put({ type: Constants.SUBMIT_SUCCESS, response: true });
        // setSession('isSubmitted', 'Y');
        // hideLoader();
        if (submitOrderRes.data.errors) {
          const checkErrorCodeFlag = checkErrorCode(
            submitOrderRes?.data?.errors && submitOrderRes?.data?.errors[0] && submitOrderRes?.data?.errors[0]?.id,
          );
          if (checkErrorCodeFlag) {
            yield put({ type: Constants.BUTTON_DISABLE, response: true });
          }
          const isAuth = submitOrderRes?.data?.errors?.some((o) => o.name === 'ORDER_FULL_AUTH_FAILED');
          if (isAuth) {
            if (apiResponse.data.errors && apiResponse.data.errors[0] && apiResponse.data.errors[0].id && apiResponse.data.errors[0].id === '3403') {
              yield put({ type: Constants.SUBMIT_SUCCESS, response: true });
              setSession('isSubmitted', 'Y');
              yield put({ type: 'CLEAR_COUPON_VALUE' });
              // if (!(data === 'ReviewOrderPage')) {
              //   // hideLoader();
              // }
            } else {
              saveItemToStore('show', 'true');
              // hideLoader();
              const errorDetails = true;
              updateSelfInstallationDetails = getServiceUrlandE2eRequestId('getAddons', submitOrderRes);
              yield put({ type: Constants.ERORR_SUBMIT, errorDetails, serviceinfo: updateSelfInstallationDetails });
              yield put({
                type: Constants.CEF_APPOINTMENT_ERROR,
                response: errorDetails,
                errorMessage: submitOrderRes?.data?.errors[0]?.notifyMessage,
              });
            }
          } else if (
            submitOrderRes.data.errors &&
            submitOrderRes.data.errors[0] &&
            submitOrderRes.data.errors[0].id &&
            submitOrderRes.data.errors[0].id === '3002'
          ) {
            updateSelfInstallationDetails = getServiceUrlandE2eRequestId('submitOrder', submitOrderRes);
            notSubmittedPayment = true;
            yield put({ type: 'NOT_SUBMITTED_PAYMENT', notSubmittedPayment, serviceinfo: updateSelfInstallationDetails });
            yield put({
              type: Constants.CEF_APPOINTMENT_ERROR,
              response: notSubmittedPayment,
              errorMessage: submitOrderRes?.data?.errors[0]?.notifyMessage,
            });
          } else {
            yield put({ type: Constants.SUBMIT_SUCCESS, response: submitOrderRes.data, flagToggle: true });
          }
        } else {
          yield put({ type: Constants.SUBMIT_SUCCESS, response: true });
          yield put({ type: Constants.SUBMIT_SUCCESS_ORDERWRITE, response: submitOrderRes?.data });
          setSession('isSubmitted', 'Y');
          // clearing couponvaue in redux
          yield put({ type: 'CLEAR_COUPON_VALUE' });
          // hideLoader();
        }
      }
      yield put({ type: Constants.POST_DATA_SELF_INSTALLATION_SUCCESS, response: apiResponse.data });
      // yield invokeTagging('cpc-selected_plan');
    } else {
      // hideLoader();
      // logError('updateSelfInstallation', apiResponse.data.errors, FE_API_ERROR);
    }
  } catch (error) {
    errorAppointment = true;

    updateSelfInstallationDetails = {
      method: 'updateSelfInstallation',
    };
    yield put({ type: Constants.ERR_OCCURED, errorAppointment, serviceinfo: updateSelfInstallationDetails });
    yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: errorAppointment, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    // logError('updateSelfInstallation', error, FE_API_JS_ERROR);
    if (error) {
      const errorLog = getErrorLogObj({
        note: 'from updateSelfInstallation sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().updateSelfInstallation}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
    // hideLoader();
  } finally {
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* updateProInstallation({ data, payload }) {
  let orderWriteCaseError = false;
  let serviceDetails = null;
  let notSubmittedPayment = false;
  let noAppointment = false;
  yield put({ type: 'NOT_SUBMITTED_PAYMENT', notSubmittedPayment });
  yield put({ type: 'NO_APPOINTMENT', noAppointment });
  yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: noAppointment, errorMessage: null });
  // let errorAppointment = false;
  // yield put({ type: Constants.ERR_OCCURED, errorAppointment });
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    showLoader();
    if (payload.checkboxValue && payload?.reminderTypeR === 'Call') {
      yield call(contactActions.postNonVzConsentApiCall, payload?.addSMSConsentParam);
    }

    const apiResponse = yield call(Actions.postPro, data);
    if (apiResponse) {
      let submitOrderRes;
      if (!isExpressCheckout()) {
        submitOrderRes = yield call(Actions.getSubmitOrder, data);
      }
      if (submitOrderRes) {
        if (submitOrderRes.data.errors) {
          const checkErrorCodeFlag = checkErrorCode(
            submitOrderRes?.data?.errors && submitOrderRes?.data?.errors[0] && submitOrderRes?.data?.errors[0]?.id,
          );
          if (checkErrorCodeFlag) {
            yield put({ type: Constants.BUTTON_DISABLE, response: true });
          }
          if (submitOrderRes?.status === 400 && checkInvalidCaseCartError(submitOrderRes.data.errors)) {
            orderWriteCaseError = true;
            serviceDetails = getServiceUrlandE2eRequestId('updateProInstallation', submitOrderRes);
            yield put({ type: 'ORDERWRITE_CASE_ERROR', response: orderWriteCaseError, serviceinfo: serviceDetails });
            yield put({
              type: Constants.CEF_APPOINTMENT_ERROR,
              response: orderWriteCaseError,
              errorMessage: submitOrderRes?.data?.errors[0]?.notifyMessage,
            });
            // hideLoader();
          } else {
            const isAuth = submitOrderRes.data.errors.some((o) => o.name === 'ORDER_FULL_AUTH_FAILED');
            if (isAuth) {
              if (
                submitOrderRes.data.errors &&
                submitOrderRes.data.errors[0] &&
                submitOrderRes.data.errors[0].id &&
                submitOrderRes.data.errors[0].id === '3403'
              ) {
                yield put({ type: Constants.SUBMIT_SUCCESS, response: true });
                setSession('isSubmitted', 'Y');
                yield put({ type: 'CLEAR_COUPON_VALUE' });
                if (!(data === 'ReviewOrderPage')) {
                  // hideLoader();
                }
              } else {
                saveItemToStore('show', 'true');
                // hideLoader();
                const errorDetails = true;
                serviceDetails = getServiceUrlandE2eRequestId('updateProInstallation', submitOrderRes);
                yield put({ type: Constants.ERORR_SUBMIT, errorDetails, serviceinfo: serviceDetails });
                yield put({
                  type: Constants.CEF_APPOINTMENT_ERROR,
                  response: errorDetails,
                  errorMessage: submitOrderRes?.data?.errors[0]?.notifyMessage,
                });
              }
            } else if (
              submitOrderRes.data.errors &&
              submitOrderRes.data.errors[0] &&
              submitOrderRes.data.errors[0].id &&
              submitOrderRes.data.errors[0].id === '3002'
            ) {
              serviceDetails = getServiceUrlandE2eRequestId('submitOrder', submitOrderRes);
              notSubmittedPayment = true;
              yield put({ type: 'NOT_SUBMITTED_PAYMENT', notSubmittedPayment, serviceinfo: serviceDetails });
              yield put({
                type: Constants.CEF_APPOINTMENT_ERROR,
                response: notSubmittedPayment,
                errorMessage: submitOrderRes?.data?.errors[0]?.notifyMessage,
              });
            } else if (
              submitOrderRes?.data?.errors &&
              submitOrderRes?.data?.errors[0] &&
              submitOrderRes?.data?.errors[0]?.id &&
              submitOrderRes?.data?.errors[0]?.id === '3999' &&
              submitOrderRes?.data?.errors[0]?.networkMessage.includes('SELECTED_APPOINTMENT_NOT_AVAILABLE')
            ) {
              setSession('noAppointment', 'Y');
              noAppointment = true;
              serviceDetails = getServiceUrlandE2eRequestId('submitOrder', submitOrderRes);
              yield put({ type: 'NO_APPOINTMENT', noAppointment, serviceinfo: serviceDetails });
              yield put({ type: 'IS_UPDATE_APPOINTMENT_SUCCESS', response: true });
              yield put({
                type: Constants.CEF_APPOINTMENT_ERROR,
                response: noAppointment,
                errorMessage: submitOrderRes?.data?.errors[0]?.notifyMessage,
              });
            } else {
              yield put({ type: Constants.SUBMIT_SUCCESS, response: submitOrderRes.data, flagToggle: true });
            }
          }
        } else {
          yield put({ type: Constants.SUBMIT_SUCCESS, response: true });
          yield put({ type: Constants.SUBMIT_SUCCESS_ORDERWRITE, response: submitOrderRes?.data });
          yield put({ type: 'CLEAR_COUPON_VALUE' });
          setSession('isSubmitted', 'Y');
        }
      }
      yield put({ type: Constants.POST_DATA_PRO_INSTALLATION_SUCCESS, response: apiResponse.data });
      yield put({ type: 'SKIP_ORDERWRITE-ETOS', response: true });
      // yield invokeTagging('cpc-selected_plan');
    } else {
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `updateProInstallation ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);

      yield put({
        type: Constants.CEF_APPOINTMENT_ERROR,
        response: noAppointment,
        errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
      });
    }
  } catch (error) {
    const errorLog = getErrorLogObj({
      eventType: 'CustomLog',
      message: 'GENERIC_PAGE',
      note: 'from updateProInstallation sagas catch',
      serviceUrl: `${getSecureBaseUrl()}${apiUrls().updateProInstallation}`,
      networkError: {
        error,
        response: error.response || null,
        message: error?.message,
        stack: error?.stack,
        subEventType: 'FeErrorS',
      },
    });
    logger(errorLog);
    yield put({ type: Constants.CEF_APPOINTMENT_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
  } finally {
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* emailValidation({ data }) {
  try {
    showLoader();
    const apiResponse = yield call(contactActions.emailValidationAPI, data);
    if (apiResponse?.data) {
      if (apiResponse?.data?.maxAttempts && apiResponse?.data?.valid === 'false') {
        yield put({ type: 'EMAIL_MAX_ATTEMPTS', response: true });
      } else if (apiResponse.data.valid === 'Manual_validation') {
        apiResponse.data.accMainEmailVal = { success: false };
      }
      yield put({ type: 'EMAIL_VALIDATION', response: apiResponse.data });
    } else {
      logError('error occured in emailValidation()');
    }
  } catch (error) {
    logError(error);
  } finally {
    hideLoader();
  }
}

function* accMaintenenceEmailValidation(data) {
  try {
    const apiResponse = yield call(contactActions.accMainEmailValidation, data);
    if (apiResponse?.data?.error !== null) {
      if (apiResponse?.data?.data === null) {
        yield put({ type: 'EMAIL_VALIDATION', response: { valid: 'true' } });
      } else {
        yield put({ type: Constants.ACC_MAIN_EMAIL_VALIDATION, response: { success: false } });
      }
    } else if (apiResponse?.data?.error === null) {
      yield put({ type: Constants.ACC_MAIN_EMAIL_VALIDATION, response: { success: true } });
    }
  } catch (error) {
    logError('error');
    hideLoader();
  }
}

function* updateAppointmentFlag() {
  yield put({ type: 'IS_UPDATE_APPOINTMENT_SUCCESS', response: false });
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_DATA_FROM_API, getDataFromApi);
  yield takeLatest(Constants.GET_DATA_FROM_APP_SCHEDULE, getDataForAppSchedule);
  yield takeLatest(Constants.SUBMIT_ORDER, submitOrder);
  yield takeLatest(Constants.POST_DATA_SELF_INSTALLATION, updateSelfInstallation);
  yield takeLatest(Constants.POST_DATA_PRO_INSTALLATION, updateProInstallation);
  yield takeLatest('UPDATE_APPOINTMENT_SUCCESS', updateAppointmentFlag);
  // SAVE_SELF_INSTALL_DATE
  yield takeLatest('SAVE_SELF_INSTALL_DATE', selfInstallDateUpdate);
  yield takeLatest(Constants.EMAIL_VALIDATION_APPOINTMENT_API, emailValidation);
  yield takeLatest(Constants.ACCOUNT_MAINTENENCE_APPOINTMENT_EMAIL_VERIFICATION, accMaintenenceEmailValidation);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
